import { formatMoney } from './useChargebeeCheckout'

// What a plan change charges today: a change scheduled for the end of the
// term charges nothing now.
export function changeChargeFor(preview) {
    return preview && preview.timing !== 'end_of_term'
        ? preview.amountDueNow
        : 0
}

export function payLabelFor({
    mode,
    selectedPlan,
    changePreview,
    pendingCompletion,
    quote,
    country,
}) {
    const planLabel = selectedPlan && selectedPlan.label
    if (mode === 'change') {
        if (changePreview && changePreview.timing === 'end_of_term')
            return `Switch to ${planLabel} when this period ends`
        const charge = changeChargeFor(changePreview)
        return charge
            ? `Pay ${formatMoney(
                  charge,
                  changePreview.currency
              )} and switch to ${planLabel}`
            : `Switch to ${planLabel || 'the new plan'}`
    }
    if (pendingCompletion) return 'Finish upgrade'
    // Tax depends on the country, so there is no amount to agree to yet.
    if (!country) return 'Choose your country to continue'
    return quote
        ? `Pay ${formatMoney(quote.amount, quote.currency)} and upgrade`
        : 'Pay and upgrade'
}

// Paying needs the amount for exactly what is selected: while a plan,
// country or coupon is being re-priced, or a VAT number is being checked or
// was refused, the amount on screen is not the one the buyer would agree to.
// A purchase also needs a complete card, unless it is finishing a payment
// already authorised.
export function canPayFor({
    mode,
    selectedPlan,
    currentPlanId,
    changePreview,
    previewStatus,
    agreed,
    pendingCompletion,
    country,
    quote,
    card,
    vatBlocksPayment,
}) {
    if (mode === 'change')
        return Boolean(
            selectedPlan &&
                changePreview &&
                !changePreview.paymentMethodRequired &&
                previewStatus === 'ready' &&
                agreed &&
                selectedPlan.planId !== currentPlanId
        )
    if (pendingCompletion) return true
    return Boolean(
        selectedPlan &&
            country &&
            !vatBlocksPayment &&
            quote.quote &&
            quote.status === 'ready' &&
            card.status === 'ready' &&
            card.complete
    )
}

// Said under the pay button so a first purchase is as explicit about the
// recurring charge as the plan change is.
export function recurringNoteFor({ quote, period }) {
    return quote
        ? `You’ll be charged ${formatMoney(quote.amount, quote.currency)} today, and then ${
              period === 'annual' ? 'once per year' : 'once per month'
          } until you cancel. You can cancel at any time from your Subscription page.`
        : 'You’ll be charged today, and then at each renewal until you cancel. You can cancel at any time from your Subscription page.'
}
